"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWaystePayablesQuery = exports.GetPayablesQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.GetPayablesQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(),
    readyForPayment: typebox_1.Type.Boolean(),
    void: typebox_1.Type.Boolean(),
    issuedBefore: typebox_1.Type.String(),
    issuedAfter: typebox_1.Type.String(),
    dueBefore: typebox_1.Type.String(),
    dueAfter: typebox_1.Type.String(),
    paidBefore: typebox_1.Type.String(),
    paidAfter: typebox_1.Type.String(),
    invoiceNumber: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    serviceOrderID: typebox_1.Type.String(),
    serviceGroupingID: typebox_1.Type.String(),
    commercialSubscriptionID: typebox_1.Type.String(),
    referenceID: typebox_1.Type.String(),
    referenceType: common_1.EntityType,
    syncedWithAccounting: typebox_1.Type.Boolean(),
    paidInFull: typebox_1.Type.Boolean(),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
}));
exports.GetWaystePayablesQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    vendorID: typebox_1.Type.String(),
    readyForPayment: typebox_1.Type.Boolean(),
    void: typebox_1.Type.Boolean(),
    issuedBefore: typebox_1.Type.String(),
    issuedAfter: typebox_1.Type.String(),
    dueBefore: typebox_1.Type.String(),
    dueAfter: typebox_1.Type.String(),
    invoiceNumber: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    syncedWithAccounting: typebox_1.Type.Boolean(),
    paidInFull: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=get-payables-query.js.map